import { render } from "./ProducerComplaint.vue?vue&type=template&id=2c77ea19"
import script from "./ProducerComplaint.vue?vue&type=script&lang=js"
export * from "./ProducerComplaint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__